import { render, staticRenderFns } from "./pengguna.vue?vue&type=template&id=fdea30aa&scoped=true&"
import script from "./pengguna.vue?vue&type=script&lang=js&"
export * from "./pengguna.vue?vue&type=script&lang=js&"
import style0 from "./pengguna.vue?vue&type=style&index=0&id=fdea30aa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdea30aa",
  null
  
)

export default component.exports